import MieGacoan from "../../assets/menuMakanan/mieGacoan.jpg"
import MieSuit from "../../assets/menuMakanan/mieSuit.jpg"
import MieHomimpa from "../../assets/menuMakanan/mieHompimpa.jpg"

import UdangKeju from "../../assets/menuMakanan/udangKeju.jpg"
import UdangRanbut from "../../assets/menuMakanan/udangRambut.jpg"
import Siomay from "../../assets/menuMakanan/siomay.jpg"
import Lumpia from "../../assets/menuMakanan/lumpia.jpg"
import PangsitGoreng from "../../assets/menuMakanan/pangsitGoreng.jpg"

import Es from "../../assets/menuMakanan/esTeh.jpg"
import VanillaLate from "../../assets/menuMakanan/vanillaLatee.jpg"
import Milo from "../../assets/menuMakanan/milo.jpg"
import Orange from "../../assets/menuMakanan/orange.jpg"
import TehTarik from "../../assets/menuMakanan/tehTarik.jpg"
import AirMineral from "../../assets/menuMakanan/airMineral.jpg"
import GreenThaiTea from "../../assets/menuMakanan/greenTeaOri.jpg"
import ThaiTeaOri from "../../assets/menuMakanan/thaiTeaOri.jpg"
import EsCoklat from "../../assets/menuMakanan/esCoklat.jpg"
import ESGobakSodr from "../../assets/menuMakanan/esGobakSodor.jpg"
import EsPetakUmpet from "../../assets/menuMakanan/esPetakUmpet.jpg"
import EsTeklek from "../../assets/menuMakanan/esTeklek.jpg"
import SlukuBatok from "../../assets/menuMakanan/slukuBalok.jpg"

const MenuAndPrice =
{
    Mie: [
        {
            id: 1,
            name: "MIE GACOAN LV 0",
            img: MieGacoan,
            price: 11000,
            deks: "Mie dengan cita rasa manis gurih tidak pedas",
            quantity: 0
        },
        {
            id: 2,
            name: "MIE GACOAN LV 1",
            img: MieGacoan,
            price: 11000,
            deks: "Mie dengan cita rasa manis gurih tingkat kepedasan level 1",
            quantity: 0
        },
        {
            id: 3,
            name: "MIE GACOAN LV 2",
            img: MieGacoan,
            price: 11000,
            deks: "Mie dengan cita rasa manis gurih tingkat kepedasan level 2",
            quantity: 0
        },
        {
            id: 4,
            name: "MIE GACOAN LV 3",
            img: MieGacoan,
            price: 11000,
            deks: "Mie dengan cita rasa manis gurih tingkat kepedasan level 3",
            quantity: 0
        },
        {
            id: 5,
            name: "MIE GACOAN LV 4",
            img: MieGacoan,
            price: 11000,
            deks: "Mie dengan cita rasa manis gurih tingkat kepedasan level 4",
            quantity: 0
        },
        {
            id: 6,
            name: "MIE GACOAN LV 6",
            img: MieGacoan,
            price: 12000,
            deks: "Mie dengan cita rasa manis gurih tingkat kepedasan level 6",
            quantity: 0
        },
        {
            id: 7,
            name: "MIE GACOAN LV 8",
            img: MieGacoan,
            price: 12000,
            deks: "Mie dengan cita rasa manis gurih tingkat kepedasan level 8",
            quantity: 0
        },

        {
            id: 8,
            name: "MIE SUIT",
            img: MieSuit,
            price: 11000,
            deks: "Mie gurih tidak pedas",
            quantity: 0
        },

        {
            id: 9,
            name: "MIE HOMPIMPA LV 1",
            img: MieHomimpa,
            price: 11000,
            deks: "Mie asin gurih dengan pedas level 1",
            quantity: 0
        },
        {
            id: 10,
            name: "MIE HOMPIMPA LV 2",
            img: MieHomimpa,
            price: 11000,
            deks: "Mie asin gurih dengan pedas level 2",
            quantity: 0
        },
        {
            id: 11,
            name: "MIE HOMPIMPA LV 3",
            img: MieHomimpa,
            price: 11000,
            deks: "Mie asin gurih dengan pedas level 3",
            quantity: 0
        },
        {
            id: 12,
            name: "MIE HOMPIMPA LV 4",
            img: MieHomimpa,
            price: 11000,
            deks: "Mie asin gurih dengan pedas level 4",
            quantity: 0
        },
        {
            id: 13,
            name: "MIE HOMPIMPA LV 6",
            img: MieHomimpa,
            price: 12000,
            deks: "Mie asin gurih dengan pedas level 6",
            quantity: 0
        },
        {
            id: 14,
            name: "MIE HOMPIMPA LV 8",
            img: MieHomimpa,
            price: 12000,
            deks: "Mie asin gurih dengan pedas level 8",
            quantity: 0
        },
    ],

    Dimsum: [
        {
            id: 1,
            name: "UDANG KEJU",
            img: UdangKeju,
            price: 10000,
            deks: "Pentol udang dengan isian keju lumer",
            quantity: 0
        },
        {
            id: 2,
            name: "UDANG RAMBUT",
            img: UdangRanbut,
            price: 10000,
            deks: "Pentol udang dengan balutan kulit pangsit yang renyah",
            quantity: 0
        },
        {
            id: 3,
            name: "SIOMAY",
            img: Siomay,
            price: 10000,
            deks: "Siomay sisajikan dengan saus spesial",
            quantity: 0
        },
        {
            id: 4,
            name: "LUMPIA UDANG",
            img: Lumpia,
            price: 10000,
            deks: "Lumpia udang",
            quantity: 0
        },
        {
            id: 5,
            name: "PANGSIT GORENG",
            img: PangsitGoreng,
            price: 11000,
            deks: "Pangsit isi 5",
            quantity: 0
        },
    ],

    Minuman: [
        {
            id: 1,
            name: "ES TEH",
            img: Es,
            price: 4500,
            deks: "",
            quantity: 0
        },
        {
            id: 2,
            name: "LEMON TEA",
            img: Es,
            price: 6500,
            deks: "",
            quantity: 0
        },
        {
            id: 3,
            name: "VANILLA LATTE",
            img: VanillaLate,
            price: 9000,
            deks: ""
        },
        {
            id: 4,
            name: "MILO",
            img: Milo,
            price: 9000,
            deks: "",
            quantity: 0
        },
        {
            id: 5,
            name: "ORANGE",
            img: Orange,
            price: 9000,
            deks: "",
            quantity: 0
        },
        {
            id: 6,
            name: "TEH TARIK",
            img: TehTarik,
            price: 7000,
            deks: "",
            quantity: 0
        },
        {
            id: 7,
            name: "AIR MINERAL",
            img: AirMineral,
            price: 4500,
            deks: "",
            quantity: 0
        },
        {
            id: 8,
            name: "GREEN THAI TEA",
            img: GreenThaiTea,
            price: 9000,
            deks: "",
            quantity: 0
        },
        {
            id: 9,
            name: "THAI TEA ORI",
            img: ThaiTeaOri,
            price: 9000,
            deks: "",
            quantity: 0
        },
        {
            id: 10,
            name: "ES COKLAT",
            img: EsCoklat,
            price: 9000,
            deks: "",
            quantity: 0
        },
        {
            id: 11,
            name: "ES GOBAK SODOR",
            img: ESGobakSodr,
            price: 10000,
            deks: "",
            quantity: 0
        },
        {
            id: 12,
            name: "ES PETAK UMPET",
            img: EsPetakUmpet,
            price: 10000,
            deks: "",
            quantity: 0
        },
        {
            id: 13,
            name: "ES TEKLEK",
            img: EsTeklek,
            price: 6500,
            deks: "",
            quantity: 0
        },
        {
            id: 14,
            name: "SLUKU BATOK",
            img: SlukuBatok,
            price: 6500,
            deks: "",
            quantity: 0
        },
    ]

}

export default MenuAndPrice